import { useMediaQuery } from "react-responsive";

const BREAKPOINT_DESKTOP_MIN_WIDTH = 992;
const BREAKPOINT_LARGE_DESKTOP_MIN_WIDTH = 1200;
const BREAKPOINT_TABLET_MIN_WIDTH = 768;

export const useIsLargeDesktop = () =>
  useMediaQuery({ minWidth: BREAKPOINT_LARGE_DESKTOP_MIN_WIDTH });
export const useIsSmallDesktop = () =>
  useMediaQuery({
    minWidth: BREAKPOINT_DESKTOP_MIN_WIDTH,
    maxWidth: BREAKPOINT_LARGE_DESKTOP_MIN_WIDTH - 1
  });
export const useIsDesktop = () =>
  useMediaQuery({ minWidth: BREAKPOINT_DESKTOP_MIN_WIDTH });
export const useIsNonDesktop = () =>
  useMediaQuery({ maxWidth: BREAKPOINT_DESKTOP_MIN_WIDTH - 1 });
export const useIsTablet = () =>
  useMediaQuery({
    minWidth: BREAKPOINT_TABLET_MIN_WIDTH,
    maxWidth: BREAKPOINT_DESKTOP_MIN_WIDTH - 1
  });
export const useIsMobile = () =>
  useMediaQuery({ maxWidth: BREAKPOINT_TABLET_MIN_WIDTH - 1 });
export const useDefaultScreenWidth = () =>
  useMediaQuery({ minWidth: BREAKPOINT_TABLET_MIN_WIDTH });

export const LargeDesktop = ({ children }) => {
  const isLargeDesktop = useIsLargeDesktop();

  return isLargeDesktop ? children : null;
};

export const SmallDesktop = ({ children }) => {
  const isSmallDesktop = useIsSmallDesktop();

  return isSmallDesktop ? children : null;
};

export const Desktop = ({ children }) => {
  const isDesktop = useIsDesktop();

  return isDesktop ? children : null;
};

export const NonDesktop = ({ children }) => {
  const isNonDesktop = useIsNonDesktop();

  return isNonDesktop ? children : null;
};

export const Tablet = ({ children }) => {
  const isTablet = useIsTablet();

  return isTablet ? children : null;
};

export const Mobile = ({ children }) => {
  const isMobile = useIsMobile();

  return isMobile ? children : null;
};

export const Default = ({ children }) => {
  const isDefault = useDefaultScreenWidth();

  return isDefault ? children : null;
};

export const useResponsiveFlag = () => {
  const isLargeDesktop = useIsLargeDesktop();
  const isSmallDesktop = useIsSmallDesktop();
  const isDesktop = useIsDesktop();
  const isNonDesktop = useIsNonDesktop();
  const isTablet = useIsTablet();
  const isMobile = useIsMobile();
  const isDefaultScreenWidth = useDefaultScreenWidth();

  return {
    isLargeDesktop,
    isSmallDesktop,
    isDesktop,
    isNonDesktop,
    isTablet,
    isMobile,
    isDefaultScreenWidth
  };
};

export const withResponsiveFlag = WrappedComponent => {
  const WithResponsiveFlag = props => {
    const responsiveFlags = useResponsiveFlag();

    return <WrappedComponent {...props} {...responsiveFlags} />;
  };

  return WithResponsiveFlag;
};

// Check if the device is primarily a touchscreen device.
// We define it as a function to allow components re-render when debugging touch screen
// devices from desktop browsers to update their UI.
//
// Solution borrowed from :
// https://css-tricks.com/touch-devices-not-judged-size/
//
export const getIsTouchDevice = () => window.matchMedia("(pointer: coarse)").matches;
